import { render, staticRenderFns } from "./DteStandardHeaderSection.vue?vue&type=template&id=0ec27654"
import script from "./DteStandardHeaderSection.vue?vue&type=script&lang=js"
export * from "./DteStandardHeaderSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports